/*
 * @Description:
 * @Author: 裴孚
 * @Date: 2022-11-15 10:37:19
 * @LastEditors: 裴孚
 * @LastEditTime: 2023-04-11 14:51:53
 * @FilePath: \ZHXY_VUE3.0\src\api\index.js
 */
import axios from 'axios'

import { warningPrompt, errorPrompt } from '../utils/promptInfo'
import { backToLogin } from '../utils/login.js'

// 创建HTTP实例
const $http = axios.create({
  baseURL: process.env.VUE_APP_BASE_API
})

// 响应拦截
$http.interceptors.response.use((response) => {
  const meta = response.data
  if (meta.code === 200) {
    return response.data
  } else if (meta.code === 500 || meta.code === 999) {
    // backToLogin()
    return warningPrompt(response.data.message)
  } else {
    return warningPrompt('code不符合规范')
  }
}, (error) => {
  return errorPrompt(error)
})
export default $http
